const LABELS: Record<string, string> = {
  'medicina-general': 'Medicina general',
  'terapia-fisica': 'Terapia física',
  'odontologia-general': 'Odontología general',
};

export function specialtyLabel(code: string): string {
  return LABELS[code] || code.charAt(0).toUpperCase() + code.slice(1);
}

export function specialtyOption(code: string): string {
  return `${specialtyLabel(code)} · ${code}`;
}

function normalize(value: string): string {
  return value.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es');
}

/** Resolve only values the tenant has assigned; arbitrary text never becomes a specialty. */
export function resolveAssignedSpecialty(value: string, assigned: string[]): string | null {
  const query = normalize(value);
  if (!query) return null;
  return assigned.find((code) => [code, specialtyLabel(code), specialtyOption(code)]
    .some((candidate) => normalize(candidate) === query)) || null;
}
